export const HINT = "hint";
export const REGISTRATION = "registration";
export const VALUE = "value";
export const ADDING_ENTRY = "addingEntry";
export const ENTRY_ADDED = "entryAdded";
export const UPDATING_ENTRY = "updatingEntry";
export const ENTRY_UPDATED = "entryUpdated";
export const DELETING_ENTRY = "deletingEntry";
export const ENTRY_DELETED = "entryDeleted";
